import React from "react";

const TourSummaryAddGigForm = ({ handleFieldChange, handleAddGig, gigFields }) => {

  return (
    <form className="hideFormLtTablet" id="addGigForm" onSubmit={handleAddGig}>

      <h3 className="form-heading">Add a gig</h3>

      <div>
        <label>Date</label>
        <input 
          type="date"
          name="date"
          id="date"
          value={gigFields.date}
          onChange={handleFieldChange}
        />
      </div>

      <div>
        <label>Venue</label>
        <input 
          type="text"
          name="venue"
          id="venue"
          placeholder="venue name"
          value={gigFields.venue}
          onChange={handleFieldChange}
        />
      </div>

      <button
        disabled={!gigFields.date || !gigFields.venue}
        className="form-button"
        type="submit"
      >Add gig</button>

    </form>
  )


};

export default TourSummaryAddGigForm;